import type { HomeStrings } from "../../types";

export const home: HomeStrings = {
  hero: {
    title: "Tackling terminal overload with one infinite canvas.",
    subtitle: "Terminals, editors, and browsers floating on an infinite zoomable surface.",
    platforms: "macOS, Windows & Linux",
  },
  download: {
    mac: "Download for macOS",
    windows: "Download for Windows",
    linux: "Download for Linux",
    latest: "Download Latest Release",
  },
  heroNewsletter: {
    placeholder: "Get the newsletter",
    subscribe: "Subscribe",
    done: "You're in. Check your inbox.",
  },
  manifesto: {
    title: "It is not another window manager.",
    body: "Tiling layouts just rearrange the windows you already have. Cate is about new ideas for how we work and code now that AI agents are part of the loop: one spatial workspace per project, where your tools and your agents share the same surface and keep their context.",
  },
  testimonials: {
    title: "Developers are watching",
    subtitle: "Real reactions from the Hacker News launch thread.",
  },
  downloadCta: {
    titleLines: ["Rethinking the workspace", "for the age of agents."],
  },
  newsletter: {
    title: "Stay in the loop",
    body: "Get updates on new features, releases, and tips. No spam, unsubscribe anytime.",
    placeholder: "you@example.com",
    subscribe: "Subscribe",
    success: "Thanks for subscribing! Check your inbox for a welcome email.",
    errorGeneric: "Something went wrong",
    errorNetwork: "Network error, try again",
  },
  unsubscribe: {
    noEmail: "No email address provided.",
    loading: "Unsubscribing...",
    doneTitle: "You've been unsubscribed",
    doneBody: "{email} has been removed from the CATE newsletter. You won't receive any more emails from us.",
    back: "Back to CATE",
    error: "Something went wrong. Please try again.",
  },
};
